// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_bF3","cls2":"CiterightMiniReport-cls2_d_z CiterightMiniReport-cls1_bF3"};